import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from 'react';

import {type RowAction} from '../../OptixTable.types';

export interface OptixTableActionsProviderProps<TData = object> {
  enableEdit: boolean;
  enableAdd: boolean;
  enableDelete: boolean;
  editingRows: TData[];
  rowChanges: Record<string, unknown>;
  setEditingRows: Dispatch<SetStateAction<TData[]>>;
  addedRows: TData[];
  setAddedRows: Dispatch<SetStateAction<TData[]>>;
  expandedRowsId: Array<number | string>;
  setExpandedRowsId: Dispatch<SetStateAction<Array<number | string>>>;
  enableRowActions: boolean;
  rowActions: Array<RowAction<TData>>;
  rowActionDisplayMode: 'icon-button' | 'menu' | 'dropdown';
  rowActionButtonSize: 'small' | 'medium' | 'large';
}

export const OptixTableActionsProviderContext =
  createContext<OptixTableActionsProviderProps<unknown> | null>(null);

export const useOptixTableActionsProviderContext =
  (): OptixTableActionsProviderProps<unknown> => {
    const optixTableContext =
      useContext<OptixTableActionsProviderProps<unknown> | null>(
        OptixTableActionsProviderContext,
      );

    if (!optixTableContext) {
      throw new Error(
        'useOptixTableActionsProviderContext has to be used within <OptixTableActionsProviderContext.Provider>',
      );
    }

    return optixTableContext;
  };
